import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {

  constructor() { }


  services = [
    {
      imageUrl: '../../../../assets/images/boostHeader.png',
      iconUrl: '../../../../assets/images/boostLogo.png',
      
      desc: [
        {
          value : 'Hire talent on demand at client site quickly and hassle free'
        },
        {
          value : 'Hire talent on demand at client site quickly and hassle free'
        },
      ],
    },
    {
      imageUrl: '../../../../assets/images/boostHeader.png',
      iconUrl: '../../../../assets/images/patch/gromoLogo.png',
      
      desc: [
        {
          value : 'Hire talent on demand at client site quickly and hassle free'
        },  
        {
          value : 'Hire talent on demand at client site quickly and hassle free'
        },
        {
          value : 'Hire talent on demand at client site quickly and hassle free'
        },
      ],
    },
    {
      imageUrl: '../../../../assets/images/boostHeader.png',
      iconUrl: '../../../../assets/images/patch/chqbookLogo.png',
      
      desc: [
        {
          value : 'Hire talent on demand at client site quickly and hassle free'
        },
        {
          value : 'Hire talent on demand at client site quickly and hassle free'
        },
        {
          value : 'Hire talent on demand at client site quickly and hassle free'
        },
      ],
    },
  ]

  ngOnInit(): void {
  }

}
